<template lang="pug">
  swatches.links(
    label="Gift Card Type"
    :required="true"
    :modelValue="$route.path"
    :options="cardLinks"
    @update:modelValue="$router.push($event)"
  )
</template>

<script setup lang="ts">
const cardLinks = [
  { label: 'Digital Card', value: '/e-gift-cards', link: '/e-gift-cards' },
  { label: 'Physical Card', value: '/physical-gift-cards', link: '/physical-gift-cards' },
]
</script>

<style lang="scss" scoped>
.links {
  margin-bottom: $space-s;
}

.links.swatches-container:deep() {
  label {
    font-size: $size-s;

    .option-count, .val {
      display: none;
    }
  }

  a.swatch {
    text-decoration: none;
    color: $color-black;

    &.active {
      color: $color-white;
    }
  }

  @include not-mobile() {
    display: flex;
    flex-direction: row;
    align-items: center;
    justify-content: space-between;

    label {
      margin-bottom: 0;
      max-width: 33%;
      flex-grow: 1;
      margin-right: $space-xxxs;
    }

    .swatches {
      flex-grow: 1;
    }
  }
}
</style>
